// extracted by mini-css-extract-plugin
export default {"container":"ElBgContainer_container__eaS4T"};